import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, map, Observable, throwError } from 'rxjs';

import { refusalReason, ServiceResponseV1 } from '@core/models/apis';
import {
  AdminShortenPeriodEndRequestV1,
  AdminShortenPeriodEndResponseV1,
  AdminSubscriptionResponseV1
} from '@core/models/subscriptions';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {
  private readonly http = inject(HttpClient);
  private readonly messageService = inject(MessageService);
  private readonly apiUrl = `${environment.apiUrl}${environment.apis.paymentsEngineAdmin}/v1/subscriptions`;

  getSubscription(subscriptionId: string): Observable<AdminSubscriptionResponseV1> {
    return this.http.get<ServiceResponseV1<AdminSubscriptionResponseV1>>(`${this.apiUrl}/${subscriptionId}`).pipe(
      map((response) => response.data!),
      catchError((error) => this.errorHandler(error, 'Error loading subscription'))
    );
  }

  shortenPeriodEnd(
    subscriptionId: string,
    body: AdminShortenPeriodEndRequestV1
  ): Observable<AdminShortenPeriodEndResponseV1> {
    return this.http
      .patch<ServiceResponseV1<AdminShortenPeriodEndResponseV1>>(`${this.apiUrl}/${subscriptionId}/period-end`, body)
      .pipe(
        map((response) => response.data!),
        catchError((error) => this.errorHandler(error, 'Error adjusting the billing period'))
      );
  }

  private errorHandler(error: unknown, serviceMessage: string): Observable<never> {
    console.error(`[SubscriptionsService] ${serviceMessage}`, error);
    this.messageService.add({ severity: 'error', summary: 'Error', detail: refusalReason(error) ?? serviceMessage });
    return throwError(() => error);
  }
}
